import { IFormBuilder } from 'shared/types';

import { genUID } from './UID';
import { getCurrentLocationId } from './location';

interface PDFFieldPayload {
  fieldId: string;
  value: string; // Attachment ID
  label: string;
  eSignRequired?: boolean;
}

export function getFormattedPDFField({
  fieldId,
  value,
  label,
  eSignRequired = false,
}: PDFFieldPayload): IFormBuilder.PDFField {
  return {
    hidden: false,
    id: fieldId,
    label,
    meta: {
      type: 'pdf',
      displayName: 'PDF Attachment',
    },
    value,
    eSignRequired,
  };
}

export function containsSpecialCharacters(str: string) {
  const specialChars = /[!@#$%^&*+=\[\]{};':"\\|,.<>\/?]+/;
  return specialChars.test(str);
}

interface TransientAttachmentsFormPayload {
  fields: IFormBuilder.PDFField[];
  formName: string;
}

export function getTransientAttachmentsFormData({
  fields,
  formName,
}: TransientAttachmentsFormPayload): IFormBuilder.TransientAttachmentsForm {
  const sectionIds: string[] = [];

  const transientForm: IFormBuilder.TransientAttachmentsForm = {
    fields: {},
    form: {
      company_id: getCurrentLocationId(),
      id: '',
      name: formName,
      sections: [],
      visibility: IFormBuilder.FormVisibility.TRANSIENT,
    },
    sections: {},
  };

  for (const field of fields) {
    const sectionId = genUID();
    sectionIds.push(sectionId);
    transientForm.fields[field.id] = field;

    transientForm.sections[sectionId] = {
      fields: [field.id],
      id: sectionId,
      title: field.label,
    };
  }

  transientForm.form.sections = sectionIds;

  return transientForm;
}
